import './Blog.css';
import { useParams, Link } from 'react-router-dom';
import blogList from '../assets/constants/blogList.js';
import Footer from '../pages/Footer.js';
import React from "react";

function Blog(props) {
    let params = useParams();

    let storySelected = blogList.find ((story) =>
    story.shortName === params.storyShortName)

    if (typeof storySelected === "undefined") {
        return (
            <div className="notValid">
                <Link className="link" to="/" >
                        <p className="backButton"> back to home </p>
                </Link>
                <p className="blogText invalidStoryText"> {params.storyShortName} is not a valid story</p>
            </div>
        )
    }
    else 
    return (
        <div className="story">
            <Link className="link" to="/" >
                <p className="backButton"> back to home </p>
            </Link>
            <Link className="link" to="/blog" >
                <p className="backButton backButtonBlogs"> back to blog list </p>
            </Link>
            <h1 className="blogStoryText"> {storySelected.title}</h1>
            {storySelected.story.map((element, index) => (
                <div>
                    {element}
                </div>

            ))}
        <Footer/>
        </div>

    )

}

export default Blog;